export default "__VITE_ASSET__DCG$nv2e__"